export const useQueryString = () => {
  const getQueryStringFromObject = (obj: Record<string, any>) => {
    // Check if the input is an object
    if (typeof obj !== 'object' || obj === null) {
      throw new Error('Input must be a non-null object')
    }

    // Create an array to store key-value pairs
    const keyValuePairs = []

    // Loop through the object's properties
    for (const key in obj) {
      if (Object.prototype?.hasOwnProperty?.call(obj, key)) {
        // Encode the key and value, then push to the array
        const encodedKey = encodeURIComponent(key)
        const encodedValue = encodeURIComponent(obj[key])
        keyValuePairs.push(`${encodedKey}=${encodedValue}`)
      }
    }

    // Join the array with '&' to create the query string
    const queryString = keyValuePairs.join('&')

    return queryString
  }

  return {
    getQueryStringFromObject
  }
}
